import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestFeedbackPost = {
    path: "/feedback/:slug",
    method: RouteHttpVerb.POST
};
